import service from '@/api/request';

/** 获取菜单列表 */
export const getTableMenuList = data => service.post<null, Global.RecordResponse>('/api/cas/menu/queryForPage', data);
/** 获取菜单的权限url列表 */
export const getMenuUrlList = data =>
  service.post<null, Global.RecordResponse>('/zqhdapi/menu/url/list', data, { mock: false });
export type menuTreeNode = {
  menuName: string;
  path: string;
  [key: string]: any;
  children?: menuTreeNode;
};
export const getLeftMenu = data => service.post<null, Array<menuTreeNode>>('/api/cas/menu/getLeftMenu', data);
export type PostMenuParams = {
  parentEid: string;
  path: string;
  menuName: string;
  status: number;
  sn: number;
  productEid: string;
};

export const addMenu = (data: PostMenuParams) => service.post('/api/cas/menu/create', data);
type PostUpdateMenuParams = {
  eid: string;
  path: string;
  menuName: string;
  status: number;
  sn: number;
  productEid: string;
};
export const updateMenu = (data: PostUpdateMenuParams) => service.post('/api/cas/menu/update', data);
export const deleteMenu = data => service.post('/api/cas/menu/delete', data);
export type MenuDetailResponse = {
  menuName: string;
  status: number;
  path: string;
  sn: number;
  [key: string]: any;
};
export const queryMenuDetail = data => service.post<null, MenuDetailResponse>('/api/cas/menu/queryByEid', data);

export type TransMenuParams = {
  eid: string;
  operate: 1 | 2 | 3 | 4;
};
export const menuTransposition = data =>
  service.post<null, MenuDetailResponse>('/api/cas/menu/menuTransposition', data);

/** 权限url相关接口 */
export type AddUrlToMenuParams = {
  resourceUrl: string;
  resourceName: string;
  menuEid: string;
};
export const addSourceUrl = (data: AddUrlToMenuParams) => service.post('/api/cas/resource/create', data);
export const updateSourceUrl = (data: AddUrlToMenuParams & { eid: string }) =>
  service.post('/api/cas/resource/update', data);
export const getSourceUrlList = data =>
  service.post<null, Global.RecordResponse>('/api/cas/resource/queryPageList', data);
export type SourceUrlResponse = {
  resourceName: string;
  resourceUrl: string;
  remarks: string;
  [key: string]: any;
};
export const querySourceUrlDetail = data => service.post<null, SourceUrlResponse>('/api/cas/resource/queryByEid', data);
export const deleteResource = data => service.post('/api/cas/resource/delete', data);
export const refreshAuthority = () => service.post('/api/cas/common/refreshAuthority');

/** 检查用户是否有权限访问该接口 */
export type ResourceCheckItem = {
  resource: string;
  flag: boolean;
};

//productCode硬编码写死
const PRODUCT_CODE = 'emcomp-back-office' as const;

export type CheckUserResourcesRequest = {
  productCode: typeof PRODUCT_CODE;
  resourceList: string[];
};

/**
 * 检查用户资源权限
 * @param params 请求参数
 */
export const checkUserResources = (params: CheckUserResourcesRequest) =>
  service.post<CheckUserResourcesRequest, ResourceCheckItem[]>('/api/cas/common/checkUserResources', params);
